import {ReportWorkingTime} from "@/shared/timr";

/**
 * Where a working time originates from, which decides the dialog it is opened in (e.g. to show, edit or duplicate it)
 */
export enum WorkingTimeOrigin {
	/** created from a working time request, opened in the working time request dialog */
	Request = "REQUEST",
	/** part of a working time DateSpan, opened in the DateSpan dialog */
	DateSpan = "DATE_SPAN",
	/** recorded on its own, opened in the working time (details) dialog */
	Standalone = "STANDALONE"
}

/**
 * Determines the {@link WorkingTimeOrigin} of a working time - a request takes precedence over a DateSpan.
 *
 * @param workingTime the working time to check
 */
export function getWorkingTimeOrigin(workingTime: Pick<ReportWorkingTime, "hasWorkingTimeRequest" | "workingTimeDateSpanId">): WorkingTimeOrigin {
	if (workingTime.hasWorkingTimeRequest) {
		return WorkingTimeOrigin.Request;
	} else if (workingTime.workingTimeDateSpanId != null) {
		return WorkingTimeOrigin.DateSpan;
	} else {
		return WorkingTimeOrigin.Standalone;
	}
}
